import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  AccountBalance as AccountBalanceIcon,
  AccountBalance,
  Email as EmailIcon,
  Settings as SettingsIcon,
  Groups,
  Receipt,
  AccountTree,
  ContactMail,
  NotificationsActive,
  Sms,
  School as SchoolIcon,
} from '@mui/icons-material';
import { academicMenu } from './academicMenu';
import { reportCardMenu } from './reportCardMenu';
import { assessmentsMenu } from './assessmentsMenu';
import { feesMenu } from './feesMenu';
import { RESOURCES, ACTIONS } from '../../../hooks/useAccessControl';

export const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: DashboardIcon, permission: { resource: RESOURCES.DASHBOARD, action: ACTIONS.READ } },
  {
    id: 'people',
    label: 'Students & Teachers Management',
    icon: PeopleIcon,
    children: [
      { id: 'students', label: 'Students', icon: PeopleIcon, permission: { resource: RESOURCES.STUDENTS, action: ACTIONS.READ } },
      { id: 'teachers', label: 'Teachers', icon: PeopleIcon, permission: { resource: RESOURCES.REPORT_CARD.TEACHERS, action: ACTIONS.READ } },
    ],
  },
  academicMenu,
  assessmentsMenu,
  reportCardMenu,
  feesMenu,
  {
    id: 'accounting',
    label: 'Accounting',
    icon: AccountBalanceIcon,
    children: [
      { id: 'accounting-transactions', label: 'Transactions', icon: Receipt, permission: { resource: RESOURCES.ACCOUNTING.TRANSACTIONS, action: ACTIONS.READ } },
      { id: 'accounting-accounts', label: 'Accounts', icon: AccountBalance, permission: { resource: RESOURCES.ACCOUNTING.ACCOUNTS, action: ACTIONS.READ } },
      { id: 'accounting-voucher-heads', label: 'Voucher Heads', icon: AccountTree, permission: { resource: RESOURCES.ACCOUNTING.VOUCHERS, action: ACTIONS.READ } },
    ],
  },
  {
    id: 'communications',
    label: 'Communications',
    icon: EmailIcon,
    children: [
      {
        id: 'communications',
        label: 'Overview',
        icon: EmailIcon,
        access: {
          any: [
            { resource: RESOURCES.COMMUNICATIONS.EMAIL, action: ACTIONS.READ },
            { resource: RESOURCES.COMMUNICATIONS.SMS, action: ACTIONS.READ },
          ],
        },
      },
      {
        id: 'communications-logs',
        label: 'Logs',
        icon: ContactMail,
        access: {
          any: [
            { resource: RESOURCES.COMMUNICATIONS.EMAIL, action: ACTIONS.READ },
            { resource: RESOURCES.COMMUNICATIONS.SMS, action: ACTIONS.READ },
          ],
        },
      },
      { id: 'communications-email-management', label: 'Email Management', icon: NotificationsActive, permission: { resource: RESOURCES.COMMUNICATIONS.EMAIL, action: ACTIONS.SEND } },
      {
        id: 'communications-sms',
        label: 'SMS Management',
        icon: Sms,
        access: {
          any: [
            { resource: RESOURCES.COMMUNICATIONS.SMS, action: ACTIONS.READ },
            { resource: RESOURCES.COMMUNICATIONS.SMS, action: ACTIONS.SEND },
          ],
        },
      },
    ],
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: SettingsIcon,
    children: [
      { id: 'settings-account', label: 'Account Settings', icon: SettingsIcon },
      { id: 'settings-users', label: 'User Management', icon: PeopleIcon, permission: { resource: RESOURCES.USERS, action: ACTIONS.READ } },
      { id: 'settings-roles', label: 'Role Management', icon: Groups, permission: { resource: RESOURCES.ROLES, action: ACTIONS.READ } },
      {
        id: 'settings-rbac',
        label: 'User Permissions',
        icon: PeopleIcon,
        access: {
          all: [
            { resource: RESOURCES.USERS, action: ACTIONS.READ },
            { resource: RESOURCES.PERMISSIONS, action: ACTIONS.READ },
          ],
          any: [
            { resource: RESOURCES.USERS, action: ACTIONS.ASSIGN },
            { resource: RESOURCES.USERS, action: ACTIONS.UPDATE },
          ],
        },
      },
      { id: 'settings-school', label: 'School Information', icon: SchoolIcon, permission: { resource: RESOURCES.SCHOOL, action: ACTIONS.READ } },
    ],
  },
];
